import {
  __name
} from "../../chunk-7QVYU63E.js";
import { Permission } from "#rbac/permission.js";
import { TeamRole } from "#rbac/teamRole.js";
const VIEWER_PERMISSIONS = [
  Permission.ViewTeamSettings,
  Permission.ViewApps,
  Permission.ViewAppLogs,
  Permission.ViewAppConfig
];
const DEVELOPER_PERMISSIONS = [
  ...VIEWER_PERMISSIONS,
  Permission.CreateApps,
  Permission.DeleteApps,
  Permission.EditAppConfig,
  Permission.ManageWebhooks,
  Permission.ViewApiKeys
];
const ADMIN_PERMISSIONS = [
  ...DEVELOPER_PERMISSIONS,
  Permission.ViewActivityLog,
  Permission.ViewActivityLogWebhooks,
  Permission.ManageActivityLogWebhooks,
  Permission.ManageAdminApiKeys,
  Permission.ManageTeamSettings,
  Permission.ManageMembers,
  Permission.AssignRoles,
  Permission.RotateKey
];
const ROLE_PERMISSION_MATRIX = {
  [TeamRole.Viewer]: VIEWER_PERMISSIONS,
  [TeamRole.Developer]: DEVELOPER_PERMISSIONS,
  [TeamRole.Admin]: ADMIN_PERMISSIONS
};
const getPermissions = /* @__PURE__ */ __name((role) => [
  ...ROLE_PERMISSION_MATRIX[role]
], "getPermissions");
const hasPermission = /* @__PURE__ */ __name((role, permission) => ROLE_PERMISSION_MATRIX[role].includes(permission), "hasPermission");
export {
  getPermissions,
  hasPermission
};
//# sourceMappingURL=rolePermissionMatrix.js.map